import * as React from 'react';
import FieldView from './views/FieldView';

interface IProps {
  icon?: string;
  readOnly?: boolean;
  placeholder?: string;
  handleClick: (event: React.MouseEvent) => void;
  handleChange?: (event: React.ChangeEvent) => void;
  labelHidden?: boolean;
  label: {
    main: string;
    sub?: string;
  };
}

const Field: React.FC<IProps> = (props) => {
  const { icon, readOnly, placeholder, handleClick, handleChange, label, labelHidden } = props;

  function renderLabel() {
    const { main, sub } =  label;
    if (!main) { return null; }
    if (main && sub) {
      return (
        <div className="label">
          <p className="main">{main}</p>
          <span className="sub">{sub}</span>
        </div>
      )
    } else {
      return (
        <div className="label">
          <p className="main">{main}</p>
        </div>
      )
    }
  }

  return (
    <FieldView>
      <a className="inner" onClick={handleClick}>
        {icon && <i className={`icon-${icon}`} />}
        <input placeholder={placeholder} readOnly={!!readOnly} onChange={handleChange} style={{ fontSize: 16 }} />
        {!labelHidden && renderLabel()}
      </a>
    </FieldView>
  );
}

export default Field;
